export default {
  restaurantoffers: {
    subtitle: "RESTAURANT OFFERS",
    title1: "Ongoing",
    title2: "Restaurant Deals",
    desc: "Take advantage of exclusive supplier offers and special pricing available for restaurants on MAHAL.",

    offer1: {
      badge: "Limited Time",
      title: "Fresh Vegetables Combo",
      desc: "Get special pricing on daily fresh vegetables from verified local suppliers.",
      li1: "Bulk order discounts",
      li2: "Same-day delivery",
      li3: "Transparent pricing",
      btn: "View Offer",
    },

    offer2: {
      badge: "Popular",
      title: "Monthly Essentials Deal",
      desc: "Save more with bulk monthly orders on rice, oil, and kitchen essentials.",
      li1: "Better bulk rates",
      li2: "Scheduled delivery",
      li3: "Priority support",
      btn: "Grab This Deal",
    },

    offer3: {
      badge: "New",
      title: "New Restaurant Offer",
      desc: "Newly onboarded restaurants get exclusive introductory pricing on first orders.",
      li1: "Special onboarding price",
      li2: "Verified suppliers",
      li3: "Easy ordering",
      btn: "Get Started",
    },
  },
};